export class EnrollContractPaymentsInfo {
  contract_edu_service_number: string = '';
  contract_edu_service_date: Date;
  contract_edu_service_reg_number: string = '';
  ticket_receipt_number: string = '';
  payment_date: Date;
  payment_amount: string = '';
  payment_bank_name: string = '';
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-contract-payments-info.ts